var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAansprakelijkheidsverzekeringOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 156.73 217.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #707e80;\n      }\n\n      .cls-3 {\n        fill: #d5d1c1;\n      }\n\n      .cls-4 {\n        fill: #455a64;\n      }\n\n      .cls-5 {\n        fill: #ffc727;\n      }\n\n      .cls-6, .cls-7 {\n        opacity: .1;\n      }\n\n      .cls-8 {\n        opacity: .3;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-7 {\n        isolation: isolate;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 79.96,
    y1: 183.64,
    x2: 81.12,
    y2: 183.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fef7e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 76.15,
    y1: 183.65,
    x2: 77.31,
    y2: 183.65,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--house-3--inject-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 156.69,
    height: 5.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 3.96,
    y: 8.43,
    width: 6.27,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 146.56,
    y: 34.24,
    width: 6.17,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 138.8,
    y: 40.17,
    width: 12.54,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8.07,
    y: 37.52,
    width: 12.54,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 146.45,
    y: 7.38,
    width: 6.27,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 212.44,
    width: 156.69,
    height: 4.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0.04,
    y: 47.6,
    width: 156.69,
    height: 4.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 14.71,
    y: 197.41,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8.73,
    y: 203.12,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 20.7,
    y: 203.12,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 131.34,
    y: 203.12,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 131.34,
    y: 61.49,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8.73,
    y: 61.5,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 42.8,
    y: 123.62,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 48.78,
    y: 117.93,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 156.69,
    height: 5.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 3.96,
    y: 5.24,
    width: 148.77,
    height: 42.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 3.96,
    y: 8.43,
    width: 6.27,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 146.56,
    y: 34.24,
    width: 6.17,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 138.8,
    y: 40.17,
    width: 12.54,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8.07,
    y: 37.52,
    width: 12.54,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 146.45,
    y: 7.38,
    width: 6.27,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 3.96,
    y: 8.43,
    width: 6.27,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.56,
    y: 34.24,
    width: 6.17,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 138.8,
    y: 40.17,
    width: 12.54,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 8.07,
    y: 37.52,
    width: 12.54,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.45,
    y: 7.38,
    width: 6.27,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1.36,
    y: 52.12,
    width: 151.91,
    height: 164.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 212.44,
    width: 156.69,
    height: 4.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.04,
    y: 47.6,
    width: 156.69,
    height: 4.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 14.71,
    y: 197.41,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 8.73,
    y: 203.12,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 20.7,
    y: 203.12,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 131.34,
    y: 203.12,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 131.34,
    y: 61.49,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 8.73,
    y: 61.5,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 42.8,
    y: 123.62,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 48.78,
    y: 117.93,
    width: 10.72,
    height: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.96,
    y: 132.16,
    width: 28.95,
    height: 44.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 18.32,
    y: 134.53,
    width: 24.23,
    height: 39.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 111.88,
    y: 132.16,
    width: 28.95,
    height: 44.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 114.24,
    y: 134.53,
    width: 24.23,
    height: 39.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.96,
    y: 71.91,
    width: 28.95,
    height: 44.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 18.32,
    y: 74.26,
    width: 24.23,
    height: 39.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 111.88,
    y: 71.91,
    width: 28.95,
    height: 44.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 114.24,
    y: 74.26,
    width: 24.23,
    height: 39.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 63.92,
    y: 71.91,
    width: 28.95,
    height: 44.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 66.28,
    y: 74.26,
    width: 24.23,
    height: 39.61
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.87 134.53 18.32 158.08 18.32 140.35 24.15 134.53 41.87 134.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.56 165.1 42.56 174.14 33.51 174.14 42.56 165.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.56 157.32 42.56 161.06 29.49 174.14 25.76 174.14 42.56 157.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.39 134.53 18.32 136.6 18.32 134.53 20.39 134.53"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "137.78 134.53 114.24 158.08 114.24 140.35 120.05 134.53 137.78 134.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.48 165.1 138.48 174.14 129.41 174.14 138.48 165.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.48 157.32 138.48 161.06 125.4 174.14 121.67 174.14 138.48 157.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.31 134.53 114.24 136.6 114.24 134.53 116.31 134.53"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.87 74.26 18.32 97.82 18.32 80.09 24.15 74.26 41.87 74.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.56 104.83 42.56 113.88 33.51 113.88 42.56 104.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.56 97.07 42.56 100.81 29.49 113.88 25.76 113.88 42.56 97.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.39 74.26 18.32 76.34 18.32 74.26 20.39 74.26"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "137.78 74.26 114.24 97.82 114.24 80.09 120.05 74.26 137.78 74.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.48 104.83 138.48 113.88 129.41 113.88 138.48 104.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.48 97.07 138.48 100.81 125.4 113.88 121.67 113.88 138.48 97.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.31 74.26 114.24 76.34 114.24 74.26 116.31 74.26"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "89.83 74.26 66.28 97.82 66.28 80.09 72.11 74.26 89.83 74.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "90.52 104.83 90.52 113.88 81.46 113.88 90.52 104.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "90.52 97.07 90.52 100.81 77.45 113.88 73.71 113.88 90.52 97.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "68.35 74.26 66.28 76.34 66.28 74.26 68.35 74.26"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 66.28,
    y: 86.67,
    width: 24.23,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 77.22,
    y: 74.26,
    width: 2.35,
    height: 39.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 54.79,
    y: 138.47,
    width: 47.69,
    height: 78.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.43,24.49l-.46-1.6h-3l-.45,1.6h-3.2l3.07-9.5h4.14l3.09,9.5h-3.19Zm-1.07-3.77l-.89-3.12-.88,3.12h1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m28.95,17.03v7.47h-2.81v-.98c-.39.69-1.13,1.11-2.14,1.11-1.93,0-3.33-1.43-3.33-3.86s1.4-3.85,3.33-3.85c.98,0,1.72.41,2.14,1.1v-.98h2.81Zm-4.15,5.41c.73,0,1.3-.6,1.3-1.68,0-1.08-.56-1.68-1.3-1.68s-1.32.56-1.32,1.68.54,1.68,1.32,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.8,19.29c-.18-.2-.44-.29-.79-.29-.69,0-1.18.54-1.18,1.26v4.24h-2.8v-7.47h2.8v.93c.35-.65,1.13-1.06,2.06-1.06s1.65.23,2.15.67c.58.51.86,1.31.86,2.37v4.56h-2.81v-4.28c0-.42-.1-.73-.28-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m42.53,18.58c-.6,0-.95.22-.92.54.03.38.54.6,1.45.75,2.35.39,3.3.88,3.3,2.27,0,1.63-1.61,2.49-3.9,2.48-2.3,0-3.8-.75-3.74-2.52h2.71c-.06.46.41.79,1.08.79s1.03-.26.97-.64c-.06-.42-1.03-.58-2.33-.86-1.52-.34-2.38-1.02-2.39-2.28,0-1.49,1.48-2.22,3.72-2.2,2.06,0,3.72.76,3.67,2.4h-2.72c.02-.46-.33-.73-.89-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m47.23,26.91v-9.88h2.8v.98c.42-.71,1.16-1.1,2.14-1.1,1.93,0,3.33,1.43,3.33,3.85s-1.39,3.86-3.33,3.86c-.98,0-1.7-.39-2.14-1.11v3.4h-2.8Zm4.15-4.47c.77,0,1.32-.56,1.32-1.68s-.55-1.68-1.32-1.68c-.73,0-1.3.6-1.3,1.68s.56,1.68,1.3,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m59.07,20.54v3.96h-2.8v-7.47h2.8v.85c.41-.65,1.14-.98,2.04-.98v2.14c-1.4-.11-2.03.59-2.04,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m69.58,17.03v7.47h-2.81v-.98c-.39.69-1.13,1.11-2.14,1.11-1.93,0-3.33-1.43-3.33-3.86s1.4-3.85,3.33-3.85c.98,0,1.72.41,2.14,1.1v-.98h2.81Zm-4.15,5.41c.73,0,1.3-.6,1.3-1.68,0-1.08-.56-1.68-1.3-1.68s-1.32.56-1.32,1.68.54,1.68,1.32,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73.44,19.42l1.68-2.4h3.15l-2.74,3.73,2.78,3.73h-3.15l-1.71-2.38v2.38h-2.8v-9.88h2.8v4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m85.86,19c.3.64.42,1.42.37,2.27h-5.42c.13.86.63,1.3,1.31,1.3.56,0,1.04-.25,1.19-.9h2.79c-.27,1.98-1.9,2.96-3.98,2.96-2.5,0-4.15-1.31-4.15-3.86s1.65-3.86,4.16-3.86c1.85,0,3.14.8,3.73,2.1Zm-2.51.94c-.01-.07-.03-.14-.05-.2-.17-.57-.59-.86-1.17-.86-.63,0-1.07.35-1.26,1.06h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m89.85,24.49h-2.8v-9.88h2.8v9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m92.32,13.74c.97,0,1.6.61,1.6,1.36s-.63,1.36-1.6,1.36-1.62-.61-1.62-1.36.64-1.36,1.62-1.36Zm1.4,10.76h-2.81v-7.47h2.81v7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m93.46,25.16h.58c.52,0,.75-.29.75-.96v-7.16h2.8v7.87c0,1.42-.64,2.38-2.26,2.38h-1.88v-2.12Zm1.12-10.07c0-.75.64-1.36,1.62-1.36.97,0,1.6.61,1.6,1.36s-.63,1.36-1.6,1.36-1.62-.61-1.62-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m101.44,19.42l1.68-2.4h3.15l-2.74,3.73,2.78,3.73h-3.15l-1.71-2.38v2.38h-2.8v-9.88h2.8v4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m110.89,19c-.69,0-1.18.56-1.18,1.28v4.22h-2.8v-9.88h2.8v3.35c.35-.68,1.17-1.06,2.06-1.06,1.19,0,2.02.38,2.5,1.11.34.49.51,1.13.51,1.93v4.56h-2.81v-4.28c0-.83-.37-1.22-1.07-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m123.47,19c.3.64.42,1.42.37,2.27h-5.42c.13.86.63,1.3,1.31,1.3.56,0,1.04-.25,1.19-.9h2.79c-.27,1.98-1.9,2.96-3.98,2.96-2.5,0-4.15-1.31-4.15-3.86s1.65-3.86,4.16-3.86c1.85,0,3.14.8,3.73,2.1Zm-2.51.94c-.01-.07-.03-.14-.05-.2-.17-.57-.59-.86-1.17-.86-.63,0-1.07.35-1.26,1.06h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m126.09,13.74c.97,0,1.6.61,1.6,1.36s-.63,1.36-1.6,1.36-1.62-.61-1.62-1.36.64-1.36,1.62-1.36Zm1.4,10.76h-2.81v-7.47h2.81v7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m136.58,14.61v9.88h-2.81v-.98c-.41.72-1.15,1.11-2.14,1.11-1.93,0-3.33-1.43-3.33-3.86s1.4-3.85,3.33-3.85c.98,0,1.7.39,2.14,1.1v-3.39h2.81Zm-4.15,7.83c.73,0,1.3-.6,1.3-1.68,0-1.08-.56-1.68-1.3-1.68s-1.32.56-1.32,1.68.54,1.68,1.32,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m141.29,18.58c-.6,0-.95.22-.92.54.03.38.54.6,1.45.75,2.35.39,3.3.88,3.3,2.27,0,1.63-1.61,2.49-3.9,2.48-2.3,0-3.8-.75-3.74-2.52h2.71c-.06.46.41.79,1.08.79s1.03-.26.97-.64c-.06-.42-1.03-.58-2.33-.86-1.52-.34-2.38-1.02-2.39-2.28,0-1.49,1.48-2.22,3.72-2.2,2.06,0,3.72.76,3.67,2.4h-2.72c.02-.46-.33-.73-.89-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m39.56,30.61l1.39,4.63,1.39-4.63h3.12l-2.85,7.47h-3.31l-2.84-7.47h3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m53.25,32.58c.3.64.42,1.42.37,2.27h-5.42c.13.86.63,1.3,1.31,1.3.56,0,1.04-.25,1.19-.9h2.79c-.27,1.98-1.9,2.96-3.98,2.96-2.5,0-4.15-1.31-4.15-3.86s1.65-3.86,4.16-3.86c1.85,0,3.14.8,3.73,2.1Zm-2.51.94c-.01-.07-.03-.14-.05-.2-.17-.57-.59-.86-1.17-.86-.63,0-1.07.35-1.26,1.06h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m57.19,34.12v3.96h-2.8v-7.47h2.8v.85c.41-.65,1.14-.98,2.04-.98v2.14c-1.4-.11-2.03.59-2.04,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m66.55,32.69l-3.18,3.3h3.18v2.08h-6.88v-2.08l3.18-3.3h-3.18v-2.08h6.88v2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m74.96,32.58c.3.64.42,1.42.37,2.27h-5.42c.13.86.63,1.3,1.31,1.3.56,0,1.04-.25,1.19-.9h2.79c-.27,1.98-1.9,2.96-3.98,2.96-2.5,0-4.15-1.31-4.15-3.86s1.65-3.86,4.16-3.86c1.85,0,3.14.8,3.73,2.1Zm-2.51.94c-.01-.07-.03-.14-.05-.2-.17-.57-.59-.86-1.17-.86-.63,0-1.07.35-1.26,1.06h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m78.95,33.01l1.68-2.4h3.15l-2.74,3.73,2.78,3.73h-3.15l-1.71-2.38v2.38h-2.8v-9.88h2.8v4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m91.37,32.58c.3.64.42,1.42.37,2.27h-5.42c.13.86.63,1.3,1.31,1.3.56,0,1.04-.25,1.19-.9h2.79c-.27,1.98-1.9,2.96-3.98,2.96-2.5,0-4.15-1.31-4.15-3.86s1.65-3.86,4.16-3.86c1.85,0,3.14.8,3.73,2.1Zm-2.51.94c-.01-.07-.03-.14-.05-.2-.17-.57-.59-.86-1.17-.86-.63,0-1.07.35-1.26,1.06h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m95.31,34.12v3.96h-2.8v-7.47h2.8v.85c.41-.65,1.14-.98,2.04-.98v2.14c-1.4-.11-2.03.59-2.04,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m99.39,27.32c.97,0,1.6.61,1.6,1.36s-.63,1.36-1.6,1.36-1.62-.61-1.62-1.36.64-1.36,1.62-1.36Zm1.4,10.76h-2.81v-7.47h2.81v7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m106.61,32.87c-.18-.2-.44-.29-.79-.29-.69,0-1.18.54-1.18,1.26v4.24h-2.8v-7.47h2.8v.93c.35-.65,1.13-1.06,2.06-1.06s1.65.23,2.15.67c.58.51.86,1.31.86,2.37v4.56h-2.81v-4.28c0-.42-.1-.73-.28-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m118.79,30.61v6.54c0,2.53-1.81,3.73-4.05,3.73s-3.82-1.15-3.98-3.14h2.8c.12.75.56,1.07,1.18,1.07.79,0,1.24-.54,1.24-1.72v-.69c-.41.64-1.15,1-2.11,1-1.93,0-3.36-1.34-3.36-3.35,0-2.12,1.4-3.56,3.33-3.56.93,0,1.69.35,2.14,1.05v-.93h2.81Zm-4.15,4.76c.79,0,1.3-.57,1.3-1.32,0-.81-.5-1.38-1.3-1.38s-1.32.52-1.32,1.36.49,1.34,1.32,1.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m17.43,24.49l-.46-1.6h-3l-.45,1.6h-3.2l3.07-9.5h4.14l3.09,9.5h-3.19Zm-1.07-3.77l-.89-3.12-.88,3.12h1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m28.95,17.03v7.47h-2.81v-.98c-.39.69-1.13,1.11-2.14,1.11-1.93,0-3.33-1.43-3.33-3.86s1.4-3.85,3.33-3.85c.98,0,1.72.41,2.14,1.1v-.98h2.81Zm-4.15,5.41c.73,0,1.3-.6,1.3-1.68,0-1.08-.56-1.68-1.3-1.68s-1.32.56-1.32,1.68.54,1.68,1.32,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m34.8,19.29c-.18-.2-.44-.29-.79-.29-.69,0-1.18.54-1.18,1.26v4.24h-2.8v-7.47h2.8v.93c.35-.65,1.13-1.06,2.06-1.06s1.65.23,2.15.67c.58.51.86,1.31.86,2.37v4.56h-2.81v-4.28c0-.42-.1-.73-.28-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m42.53,18.58c-.6,0-.95.22-.92.54.03.38.54.6,1.45.75,2.35.39,3.3.88,3.3,2.27,0,1.63-1.61,2.49-3.9,2.48-2.3,0-3.8-.75-3.74-2.52h2.71c-.06.46.41.79,1.08.79s1.03-.26.97-.64c-.06-.42-1.03-.58-2.33-.86-1.52-.34-2.38-1.02-2.39-2.28,0-1.49,1.48-2.22,3.72-2.2,2.06,0,3.72.76,3.67,2.4h-2.72c.02-.46-.33-.73-.89-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m47.23,26.91v-9.88h2.8v.98c.42-.71,1.16-1.1,2.14-1.1,1.93,0,3.33,1.43,3.33,3.85s-1.39,3.86-3.33,3.86c-.98,0-1.7-.39-2.14-1.11v3.4h-2.8Zm4.15-4.47c.77,0,1.32-.56,1.32-1.68s-.55-1.68-1.32-1.68c-.73,0-1.3.6-1.3,1.68s.56,1.68,1.3,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m59.07,20.54v3.96h-2.8v-7.47h2.8v.85c.41-.65,1.14-.98,2.04-.98v2.14c-1.4-.11-2.03.59-2.04,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m69.58,17.03v7.47h-2.81v-.98c-.39.69-1.13,1.11-2.14,1.11-1.93,0-3.33-1.43-3.33-3.86s1.4-3.85,3.33-3.85c.98,0,1.72.41,2.14,1.1v-.98h2.81Zm-4.15,5.41c.73,0,1.3-.6,1.3-1.68,0-1.08-.56-1.68-1.3-1.68s-1.32.56-1.32,1.68.54,1.68,1.32,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m73.44,19.42l1.68-2.4h3.15l-2.74,3.73,2.78,3.73h-3.15l-1.71-2.38v2.38h-2.8v-9.88h2.8v4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m85.86,19c.3.64.42,1.42.37,2.27h-5.42c.13.86.63,1.3,1.31,1.3.56,0,1.04-.25,1.19-.9h2.79c-.27,1.98-1.9,2.96-3.98,2.96-2.5,0-4.15-1.31-4.15-3.86s1.65-3.86,4.16-3.86c1.85,0,3.14.8,3.73,2.1Zm-2.51.94c-.01-.07-.03-.14-.05-.2-.17-.57-.59-.86-1.17-.86-.63,0-1.07.35-1.26,1.06h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m89.85,24.49h-2.8v-9.88h2.8v9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m92.32,13.74c.97,0,1.6.61,1.6,1.36s-.63,1.36-1.6,1.36-1.62-.61-1.62-1.36.64-1.36,1.62-1.36Zm1.4,10.76h-2.81v-7.47h2.81v7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m93.46,25.16h.58c.52,0,.75-.29.75-.96v-7.16h2.8v7.87c0,1.42-.64,2.38-2.26,2.38h-1.88v-2.12Zm1.12-10.07c0-.75.64-1.36,1.62-1.36.97,0,1.6.61,1.6,1.36s-.63,1.36-1.6,1.36-1.62-.61-1.62-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m101.44,19.42l1.68-2.4h3.15l-2.74,3.73,2.78,3.73h-3.15l-1.71-2.38v2.38h-2.8v-9.88h2.8v4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m110.89,19c-.69,0-1.18.56-1.18,1.28v4.22h-2.8v-9.88h2.8v3.35c.35-.68,1.17-1.06,2.06-1.06,1.19,0,2.02.38,2.5,1.11.34.49.51,1.13.51,1.93v4.56h-2.81v-4.28c0-.83-.37-1.22-1.07-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m123.47,19c.3.64.42,1.42.37,2.27h-5.42c.13.86.63,1.3,1.31,1.3.56,0,1.04-.25,1.19-.9h2.79c-.27,1.98-1.9,2.96-3.98,2.96-2.5,0-4.15-1.31-4.15-3.86s1.65-3.86,4.16-3.86c1.85,0,3.14.8,3.73,2.1Zm-2.51.94c-.01-.07-.03-.14-.05-.2-.17-.57-.59-.86-1.17-.86-.63,0-1.07.35-1.26,1.06h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m126.09,13.74c.97,0,1.6.61,1.6,1.36s-.63,1.36-1.6,1.36-1.62-.61-1.62-1.36.64-1.36,1.62-1.36Zm1.4,10.76h-2.81v-7.47h2.81v7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.58,14.61v9.88h-2.81v-.98c-.41.72-1.15,1.11-2.14,1.11-1.93,0-3.33-1.43-3.33-3.86s1.4-3.85,3.33-3.85c.98,0,1.7.39,2.14,1.1v-3.39h2.81Zm-4.15,7.83c.73,0,1.3-.6,1.3-1.68,0-1.08-.56-1.68-1.3-1.68s-1.32.56-1.32,1.68.54,1.68,1.32,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m141.29,18.58c-.6,0-.95.22-.92.54.03.38.54.6,1.45.75,2.35.39,3.3.88,3.3,2.27,0,1.63-1.61,2.49-3.9,2.48-2.3,0-3.8-.75-3.74-2.52h2.71c-.06.46.41.79,1.08.79s1.03-.26.97-.64c-.06-.42-1.03-.58-2.33-.86-1.52-.34-2.38-1.02-2.39-2.28,0-1.49,1.48-2.22,3.72-2.2,2.06,0,3.72.76,3.67,2.4h-2.72c.02-.46-.33-.73-.89-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m39.56,30.61l1.39,4.63,1.39-4.63h3.12l-2.85,7.47h-3.31l-2.84-7.47h3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m53.25,32.58c.3.64.42,1.42.37,2.27h-5.42c.13.86.63,1.3,1.31,1.3.56,0,1.04-.25,1.19-.9h2.79c-.27,1.98-1.9,2.96-3.98,2.96-2.5,0-4.15-1.31-4.15-3.86s1.65-3.86,4.16-3.86c1.85,0,3.14.8,3.73,2.1Zm-2.51.94c-.01-.07-.03-.14-.05-.2-.17-.57-.59-.86-1.17-.86-.63,0-1.07.35-1.26,1.06h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m57.19,34.12v3.96h-2.8v-7.47h2.8v.85c.41-.65,1.14-.98,2.04-.98v2.14c-1.4-.11-2.03.59-2.04,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m66.55,32.69l-3.18,3.3h3.18v2.08h-6.88v-2.08l3.18-3.3h-3.18v-2.08h6.88v2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m74.96,32.58c.3.64.42,1.42.37,2.27h-5.42c.13.86.63,1.3,1.31,1.3.56,0,1.04-.25,1.19-.9h2.79c-.27,1.98-1.9,2.96-3.98,2.96-2.5,0-4.15-1.31-4.15-3.86s1.65-3.86,4.16-3.86c1.85,0,3.14.8,3.73,2.1Zm-2.51.94c-.01-.07-.03-.14-.05-.2-.17-.57-.59-.86-1.17-.86-.63,0-1.07.35-1.26,1.06h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m78.95,33.01l1.68-2.4h3.15l-2.74,3.73,2.78,3.73h-3.15l-1.71-2.38v2.38h-2.8v-9.88h2.8v4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m91.37,32.58c.3.64.42,1.42.37,2.27h-5.42c.13.86.63,1.3,1.31,1.3.56,0,1.04-.25,1.19-.9h2.79c-.27,1.98-1.9,2.96-3.98,2.96-2.5,0-4.15-1.31-4.15-3.86s1.65-3.86,4.16-3.86c1.85,0,3.14.8,3.73,2.1Zm-2.51.94c-.01-.07-.03-.14-.05-.2-.17-.57-.59-.86-1.17-.86-.63,0-1.07.35-1.26,1.06h2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m95.31,34.12v3.96h-2.8v-7.47h2.8v.85c.41-.65,1.14-.98,2.04-.98v2.14c-1.4-.11-2.03.59-2.04,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m99.39,27.32c.97,0,1.6.61,1.6,1.36s-.63,1.36-1.6,1.36-1.62-.61-1.62-1.36.64-1.36,1.62-1.36Zm1.4,10.76h-2.81v-7.47h2.81v7.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m106.61,32.87c-.18-.2-.44-.29-.79-.29-.69,0-1.18.54-1.18,1.26v4.24h-2.8v-7.47h2.8v.93c.35-.65,1.13-1.06,2.06-1.06s1.65.23,2.15.67c.58.51.86,1.31.86,2.37v4.56h-2.81v-4.28c0-.42-.1-.73-.28-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m118.79,30.61v6.54c0,2.53-1.81,3.73-4.05,3.73s-3.82-1.15-3.98-3.14h2.8c.12.75.56,1.07,1.18,1.07.79,0,1.24-.54,1.24-1.72v-.69c-.41.64-1.15,1-2.11,1-1.93,0-3.36-1.34-3.36-3.35,0-2.12,1.4-3.56,3.33-3.56.93,0,1.69.35,2.14,1.05v-.93h2.81Zm-4.15,4.76c.79,0,1.3-.57,1.3-1.32,0-.81-.5-1.38-1.3-1.38s-1.32.52-1.32,1.36.49,1.34,1.32,1.34Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.24,
    y: 86.67,
    width: 24.23,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.18,
    y: 74.27,
    width: 2.35,
    height: 39.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.24,
    y: 146.92,
    width: 24.23,
    height: 2.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 125.18,
    y: 134.53,
    width: 2.35,
    height: 39.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "42.55 146.92 42.55 149.27 18.32 149.27 18.32 146.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "29.26 134.53 31.62 134.53 31.62 174.14 29.26 174.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "31.62 113.88 29.26 113.88 29.26 74.26 31.62 74.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "18.32 89.02 18.32 86.67 42.55 86.67 42.55 89.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.63,
    y: 138.48,
    width: 23.85,
    height: 78.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.18,
    y: 143.6,
    width: 16.76,
    height: 52.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.93 143.6 98.93 148.26 82.18 171.85 82.18 160.67 94.3 143.6 98.93 143.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.93 167.99 98.93 179.16 86.61 196.55 82.18 196.55 82.18 191.62 98.93 167.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.93 163.08 98.93 165.44 82.18 189.08 82.18 186.71 98.93 163.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "92.61 143.6 82.18 158.3 82.18 153.67 89.32 143.6 92.61 143.6"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 82.18,
    y: 181.76,
    width: 16.76,
    height: 3.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 79.96,
    y: 179.22,
    width: 1.16,
    height: 8.83
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 54.79,
    y: 138.47,
    width: 23.85,
    height: 78.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 58.34,
    y: 143.6,
    width: 16.76,
    height: 52.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "75.08 143.6 75.08 148.26 58.34 171.85 58.34 160.67 70.45 143.6 75.08 143.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "75.08 167.99 75.08 179.16 62.76 196.55 58.34 196.55 58.34 191.62 75.08 167.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "75.08 163.08 75.08 165.44 58.34 189.08 58.34 186.71 75.08 163.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "68.77 143.6 58.34 158.3 58.34 153.67 65.48 143.6 68.77 143.6"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.15,
    y: 179.23,
    width: 1.16,
    height: 8.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 58.34,
    y: 181.77,
    width: 16.76,
    height: 3.76
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAansprakelijkheidsverzekeringOpen);
export default __webpack_public_path__ + "static/media/aansprakelijkheidsverzekering-open.617f20d65ac241ace8d47d0e0f2a150d.svg";
export { ForwardRef as ReactComponent };